// Константы для RoomLaunchBlock
export const MAX_FILE_SIZE = 1024 * 1024 * 1024; // 1 ГБ в байтах
export const VIRTUAL_SPACE_TAG_ID = 'f630ed3c4dc34c99ba0c683558deb470';

// Типы для загруженных файлов
export interface UploadedFile {
  file: File;
  fileId?: string;
}

export interface UploadedFiles {
  unity?: UploadedFile;
  windows?: UploadedFile;
  macos?: UploadedFile;
  android?: UploadedFile;
}

export interface UploadProgress {
  [key: string]: {
    progress: number;
    isUploading: boolean;
    uppy?: any;
    progressInterval?: any;
  };
}

// Платформы для API
export const PLATFORMS = [
  { key: 'unity', platformType: 'Unity', label: '.unitypackage', required: true, accept: '.unitypackage' },
  { key: 'windows', platformType: 'Windows', label: 'Windows', required: true, accept: '.zip' },
  { key: 'macos', platformType: 'MacOS', label: 'MacOS', required: false, accept: '.zip' },
  { key: 'android', platformType: 'Android', label: 'Android', required: false, accept: '.zip' },
] as const;
// Константы для RoomLaunchBlock
export const MAX_FILE_SIZE = 1024 * 1024 * 1024; // 1 ГБ в байтах
export const VIRTUAL_SPACE_TAG_ID = 'f630ed3c4dc34c99ba0c683558deb470';

// Типы для загруженных файлов
export interface UploadedFile {
  file: File;
  fileId?: string;
}

export interface UploadedFiles {
  unity?: UploadedFile;
  windows?: UploadedFile;
  macos?: UploadedFile;
  android?: UploadedFile;
}

export interface UploadProgress {
  [key: string]: {
    progress: number;
    isUploading: boolean;
    uppy?: any;
    progressInterval?: any;
  };
}

// Платформы для API
export const PLATFORMS = [
  { key: 'unity', platformType: 'Unity', label: '.unitypackage', required: true, accept: '.unitypackage' },
  { key: 'windows', platformType: 'Windows', label: 'Windows', required: true, accept: '.zip' },
  { key: 'macos', platformType: 'MacOS', label: 'MacOS', required: false, accept: '.zip' },
  { key: 'android', platformType: 'Android', label: 'Android', required: false, accept: '.zip' },
] as const;
